import LockIcon from "@uui/Lock03";
import NoVideoIcon from "@uui/VideoRecorderOff";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import IconBackground from "@rui/IconBackground";
import { Column, Row, StackProps } from "@rui/Stack";

export const ClipWrapper = styled(Column)({
  width: "160px",
  border: "1px solid #0000000A",
  borderRadius: "4px",
  height: "100%",
  overflow: "hidden",
  boxShadow: "0px 1px 16px 0px #231F380A",
});

export const ClipDetails = styled(Column)(({ theme }) => ({
  padding: theme.spacing(0.5, 1, 1),
  flex: 1,
  justifyContent: "space-between",
  alignItems: "flex-start",
}));

export const ClipContent = styled(Typography)(({ theme }) => ({
  letterSpacing: "-0.01em",
  fontSize: "11px",
  color: theme.palette.shades.neutral[500],
  borderLeft: `2px solid ${theme.palette.shades.neutral[100]}`,
  paddingLeft: theme.spacing(1),
  lineHeight: 17 / 14,
  fontFamily: theme.typography.fontFamilySecondary,
}));

export const Thumbnail = styled(Column)(({ theme }) => ({
  width: "160px",
  height: "96px",
  position: "relative",
  overflow: "hidden",
  objectFit: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  backgroundColor: theme.palette.shades.neutral[900],
  marginBottom: theme.spacing(0.5),
}));

type ThumbnailOverlayProps = StackProps & { icon: "lock" | "no_video" };

export const ThumbnailOverlay = styled(
  ({ icon, ...props }: ThumbnailOverlayProps) => (
    <Row {...props} variant="center">
      <IconBackground height={28} sx={{ bgcolor: "#FFFFFF4D" }}>
        {icon === "lock" ? <LockIcon /> : <NoVideoIcon />}
      </IconBackground>
    </Row>
  )
)({
  backgroundColor: "#00000040",
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  "& svg": {
    color: "#FFF",
  },
});

export const UpNext = styled(Column)(({ theme }) => ({
  color: "#FFF",
  textAlign: "center",
  padding: theme.spacing(0.5, 1),
  backgroundColor: theme.palette.transparent.white[20],
  borderRadius: "4px",
}));
